export function create({ payload }) {
  return {
    url: `/api/vehicles`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function update({ params, payload }) {
  return {
    url: `/api/vehicles/${params.id}`,
    method: 'PUT',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function remove({ params }) {
  return {
    url: `/api/vehicles/${params.id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
  }
}

export function list() {
  return {
    url: `/api/users/me/vehicles`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
  }
}
